export enum EidasToLabel {
  eidas1 = 'Faible',
  eidas2 = 'Substantiel',
  eidas3 = 'Élevé',
}
